import React from "react";
import { useFormContext } from "react-hook-form";

import style from "../AddVaccineForm.module.css";
import { BatchNumberField } from "./BatchNumberField";
import { TextField } from "./TextField";
import { VACCINE_MODE } from "./VaccineModeSwitch";

export const VaccineDetailsSection = ({
  mode,
  derivedDoseMl = null,
  batches = [],
  isLoadingBatches = false,
  recordedBatch = null,
  children = null,
}) => {
  const { watch } = useFormContext();
  const isGivenElsewhere = watch("givenElsewhere");
  const isHealthlinkMode = mode === VACCINE_MODE.HEALTHLINK;
  // Where the product determines the dose it is filled in on selection, so the field is
  // a derived value and editing it can only introduce a transcription error (KIN-1679).
  // Locked only for products we hold a dose for; everything else stays hand-entered,
  // because a null dose means "no reference value", not zero. Same treatment the
  // manufacturer beside it already gets.
  const isDoseDerivedFromProduct = isHealthlinkMode && derivedDoseMl !== null;

  return (
    <>
      <h6 className={style.sectionHeader}>Vaccine details</h6>

      {/* Four columns while the administration fields are hidden, so the survivors keep the
          same width as the fields in the row above rather than stretching to fill the space
          the hidden ones left. Reaction and Reaction Date are passed in as children and
          share this row, because two fields here and two there made two half-empty rows
          where one full one says the same thing (KIN-1883). */}
      <div
        className={
          isGivenElsewhere ? style.bottomSectionInputGrid : style.inputRowThree
        }
      >
        {/* A vial number this practice never held (KIN-1883). */}
        {/* Picked from the batch registry in HealthLink mode, typed in Manual mode: a
            manual entry is a dose from outside the national list — one given abroad, or
            a historical record — and has no registry behind it (KIN-1740). */}
        {!isGivenElsewhere &&
          (isHealthlinkMode ? (
            <BatchNumberField
              batches={batches}
              isLoadingBatches={isLoadingBatches}
              recordedBatch={recordedBatch}
            />
          ) : (
            <TextField name="batchNo" label="Batch No" required />
          ))}

        <TextField
          name="vaccineManufacturer"
          label="Manufacturer"
          placeholder={isHealthlinkMode ? "Auto-filled from vaccine" : ""}
          disabled={isHealthlinkMode}
        />

        <TextField
          name="dose"
          label="Dose"
          inputMode="decimal"
          wrapperClass="mlInput"
          pattern="[0-9]*\.?[0-9]*"
          required
          disabled={isDoseDerivedFromProduct}
          onChange={(event) => {
            event.target.value = event.target.value
              .replace(/[^0-9.]/g, "")
              .replace(/^(\d*\.?\d*).*$/, "$1");
          }}
        />

        {children}
      </div>
    </>
  );
};
